export const getAll = async (supabase) => {
  try {
    const result = await supabase
      .from('changelog_entries')
      .select('*')
      .order('date', { ascending: false });
    
    if (result.error) {
      console.error('getAll changelog method:', result.error);
      return [];
    }
    
    return result.data || [];
  } catch (error) {
    console.error('getAll changelog method:', error);
    return [];
  }
};

export const create = async (supabase, entry) => {
  try {
    const result = await supabase
      .from('changelog_entries')
      .insert([{
        date: entry.date,
        title: entry.title,
        description: entry.description
      }]);
    
    if (result.error) {
      console.error('create changelog method:', result.error);
      return { success: false, error: result.error.message };
    }
    
    return { success: true };
  } catch (error) {
    console.error('create changelog method:', error);
    return { success: false, error: 'An unexpected error occurred.' };
  }
};

export const updateById = async (supabase, id, entry) => {
  try {
    const result = await supabase
      .from('changelog_entries')
      .update({
        date: entry.date,
        title: entry.title,
        description: entry.description
      })
      .eq('id', id);
    
    if (result.error) {
      console.error('updateById changelog method:', result.error);
      return { success: false, error: result.error.message };
    }
    
    return { success: true };
  } catch (error) {
    console.error('updateById changelog method:', error);
    return { success: false, error: 'An unexpected error occurred.' };
  }
};

export const deleteById = async (supabase, id) => {
  try {
    const result = await supabase
      .from('changelog_entries')
      .delete()
      .eq('id', id);
    
    if (result.error) {
      console.error('deleteById changelog method:', result.error);
      return { success: false };
    }
    
    return { success: true };
  } catch (error) {
    console.error('deleteById changelog method:', error);
    return { success: false };
  }
};

